// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lti-root {
    display: inline-block;
}

.lti-modal .modal__content {
    overflow-y: auto;
}

.lti-actions {
    align-items: center;
    display: flex;
    gap: 10px;
    margin-top: 16px;
}

.lti-section {
    border: 1px solid #ddd;
    border-radius: 4px;
    margin: 0 0 16px;
    padding: 12px;
}

[data-theme="dark"] .lti-section {
    border-color: #3a463e;
}

.lti-section legend {
    font-weight: 600;
    padding: 0 4px;
}

.lti-rows {
    list-style: none;
    margin: 0;
    padding: 0;
}

.lti-row {
    border-bottom: 1px solid #eee;
    padding: 8px 0;
}

.lti-row:last-child {
    border-bottom: none;
}

[data-theme="dark"] .lti-row {
    border-bottom-color: #2c3a33;
}

.lti-row .checkbox span {
    align-items: baseline;
    display: flex;
    gap: 6px;
    min-width: 0;
}

.lti-row .checkbox span.lti-row-url {
    color: #666;
    display: block;
    flex: 1 1 0;
    font-size: 0.85em;
    margin-left: 10px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

[data-theme="dark"] .lti-row .checkbox span.lti-row-url {
    color: #9fb0a6;
}

.lti-replace {
    display: block;
    margin: 6px 0 0 28px;
}

.lti-result ul {
    margin: 12px 0;
}

@media (max-width: 640px) {
    .lti-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .lti-actions .button {
        display: flex;
        justify-content: center;
        min-height: 44px;
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Linktree/LinktreeImport.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,WAAW;IACf;AACJ","sourcesContent":[".lti-root {\n    display: inline-block;\n}\n\n.lti-modal .modal__content {\n    overflow-y: auto;\n}\n\n.lti-actions {\n    align-items: center;\n    display: flex;\n    gap: 10px;\n    margin-top: 16px;\n}\n\n.lti-section {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin: 0 0 16px;\n    padding: 12px;\n}\n\n[data-theme=\"dark\"] .lti-section {\n    border-color: #3a463e;\n}\n\n.lti-section legend {\n    font-weight: 600;\n    padding: 0 4px;\n}\n\n.lti-rows {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.lti-row {\n    border-bottom: 1px solid #eee;\n    padding: 8px 0;\n}\n\n.lti-row:last-child {\n    border-bottom: none;\n}\n\n[data-theme=\"dark\"] .lti-row {\n    border-bottom-color: #2c3a33;\n}\n\n.lti-row .checkbox span {\n    align-items: baseline;\n    display: flex;\n    gap: 6px;\n    min-width: 0;\n}\n\n.lti-row .checkbox span.lti-row-url {\n    color: #666;\n    display: block;\n    flex: 1 1 0;\n    font-size: 0.85em;\n    margin-left: 10px;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n[data-theme=\"dark\"] .lti-row .checkbox span.lti-row-url {\n    color: #9fb0a6;\n}\n\n.lti-replace {\n    display: block;\n    margin: 6px 0 0 28px;\n}\n\n.lti-result ul {\n    margin: 12px 0;\n}\n\n@media (max-width: 640px) {\n    .lti-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .lti-actions .button {\n        display: flex;\n        justify-content: center;\n        min-height: 44px;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
